import i18n from '@/i18n'
import { driveUnitService } from '@/services/driveUnit.service'
import { mapActions } from 'vuex'
import {REGEX, SnackbarStyle} from '@/constants/constants'
import { dialogTypes } from '@/constants/dialogTypes'
import DriveUnitDialogFirstTabComponent from './tabs/first/DriveUnitDialogFirstTabComponent.vue'
import DriveUnitDialogSecondTabComponent from './tabs/second/DriveUnitDialogSecondTabComponent.vue'
import DriveUnitDialogThirdTabComponent from './tabs/third/DriveUnitDialogThirdTabComponent.vue'
import DriveUnitDialogFourthTabComponent from './tabs/fourth/DriveUnitDialogFourthTabComponent.vue'
import Vue from 'vue'

export default {
    name: 'DriveUnitDialogComponent',
    components: {
        DriveUnitDialogFirstTabComponent,
        DriveUnitDialogSecondTabComponent,
        DriveUnitDialogThirdTabComponent,
        DriveUnitDialogFourthTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        items: [
            {
                key: 'driveUnitDialogFirstTab',
                tab: i18n.t('data'),
                tooltip: i18n.t('driveUnit.dialog.tabs.first'),
                icon: 'mdi-form-textbox',
                content: {
                    _uid: 'n99dK5yK17',
                    component: 'DriveUnitDialogFirstTabComponent',
                    headline: 'DriveUnitDialogFirstTabComponent'
                },
                model: {
                    enterpriseId: null,
                    Name: null,
                    ecologicalUnitId: null,
                    farmId: null,
                    area: null,
                    headWidth: null,
                    disableEnterpriseSelector: false
                },
                validForm: false
            },
            {
                key: 'driveUnitDialogSecondTab',
                tab: i18n.t('details'),
                tooltip: i18n.t('driveUnit.dialog.tabs.second'),
                icon: 'mdi-form-textarea',
                content: {
                    _uid: '42UOYL2fEE',
                    component: 'DriveUnitDialogSecondTabComponent',
                    headline: 'DriveUnitDialogSecondTabComponent'
                },
                model: {
                    variety: null,
                    age: null,
                    description: null
                },
                validForm: false
            },
            {
                key: 'driveUnitDialogThirdTab',
                tab: i18n.t('driveUnit.dialog.tabs.third'),
                tooltip: i18n.t('driveUnit.dialog.tabs.third'),
                icon: 'mdi-form-textarea',
                content: {
                    _uid: '42UOYL2fEF',
                    component: 'DriveUnitDialogThirdTabComponent',
                    headline: 'DriveUnitDialogThirdTabComponent'
                },
                model: {
                    harvestSpeed: null,
                    machineEfficiency: null,
                    plantingWidth: null,
                    nivelationWidth: null,
                    visibility: null,
                    distanceToMill: null
                },
                validForm: false
            },
            {
                key: 'driveUnitDialogFourthTab',
                tab: i18n.t('driveUnit.dialog.tabs.fourth'),
                tooltip: i18n.t('driveUnit.dialog.tabs.fourth'),
                icon: 'mdi-form-textarea',
                content: {
                    _uid: '42UOYL2fEG',
                    component: 'DriveUnitDialogFourthTabComponent',
                    headline: 'DriveUnitDialogFourthTabComponent'
                },
                model: {
                    tchp: null,
                    tch: null,
                    TCHR: null,
                    grooves: null,
                    kgPerGroove: null,
                    groovesPerHectare: null
                },
                validForm: false
            },
        ],
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            greaterThanEqual: (value, minValue) => value == null || value === '' || minValue == null || Number(value) >= Number(minValue) || `${i18n.t('error.greaterThanEqual', {value: minValue})}`,
            number: (value, maxValue) => value == null || value === '' || (value && (value.toString().replace('.', '').length <= maxValue) && REGEX.numberWithDecimal.test(value.toString())) ||  `${i18n.t('maxNumberWithDecimalPositives', {max: maxValue})}`,
        },
        // flag para resetear validaciones en los formularios
        resetForms: false
    }),
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.items[0].model.disableEnterpriseSelector = false
            this.items[0].model.enterpriseId = null
            this.items[0].model.Name = null
            this.items[0].model.ecologicalUnitId = null
            this.items[0].model.farmId = null
            this.items[0].model.area = null
            this.items[0].model.headWidth = null
            this.items[1].model.variety = null
            this.items[1].model.age = null
            this.items[1].model.description = null
            this.items[2].model.harvestSpeed = null
            this.items[2].model.machineEfficiency = null
            this.items[2].model.plantingWidth = null
            this.items[2].model.nivelationWidth = null
            this.items[2].model.visibility = null
            this.items[2].model.distanceToMill = null
            this.items[3].model.tchp = null
            this.items[3].model.tch = null
            this.items[3].model.TCHR = null
            this.items[3].model.grooves = null
            this.items[3].model.kgPerGroove = null
            this.items[3].model.groovesPerHectare = null

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(dialogTypes.DRIVE_UNIT.key)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const driveUnitDto = this.getDriveUnitDto()
            if (this.model.update) {
                driveUnitService.update(driveUnitDto, this.model.driveUnitId).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: i18n.t('driveUnit.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                })
            } else {
                driveUnitService.create(this.model.zoneId, driveUnitDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: i18n.t('driveUnit.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                })
            }
            this.resetFields()
            this.$emit('onSave')
            this.cancel()
        },
        /**
         * Genera el dto para creación o actualización
         */
        getDriveUnitDto() {
            const today = new Date();
            const lastTimeUpdated = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

            const dto = {
                geometry: this.model.geometry,
                enterpriseId: this.items[0].model.enterpriseId,
                zoneId: this.model.zoneId,
                Name: this.items[0].model.Name,
                ecologicalUnitId: this.items[0].model.ecologicalUnitId,
                farmId: this.items[0].model.farmId,
                area: parseFloat(this.items[0].model.area),
                headWidth: parseFloat(this.items[0].model.headWidth),
                variety: this.items[1].model.variety,
                age: this.items[1].model.age,
                description: this.items[1].model.description,
                harvestSpeed: parseFloat(this.items[2].model.harvestSpeed),
                machineEfficiency: parseFloat(this.items[2].model.machineEfficiency),
                plantingWidth: parseFloat(this.items[2].model.plantingWidth),
                nivelationWidth: parseFloat(this.items[2].model.nivelationWidth),
                visibility: parseFloat(this.items[2].model.visibility),
                distanceToMill: parseFloat(this.items[2].model.distanceToMill),
                tchp: parseFloat(this.items[3].model.tchp),
                tch: parseFloat(this.items[3].model.tch),
                TCHR: parseFloat(this.items[3].model.TCHR),
                grooves: parseFloat(this.items[3].model.grooves),
                kgPerGroove: parseFloat(this.items[3].model.kgPerGroove),
                groovesPerHectare: parseFloat(this.items[3].model.groovesPerHectare),
                lastUpdate: lastTimeUpdated
            }
            return dto
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                    this.items[0].model.disableEnterpriseSelector = newModel.disableEnterpriseSelector
                    this.items[0].model.enterpriseId = newModel.enterpriseId
                    this.items[0].model.Name = newModel.Name
                    this.items[0].model.ecologicalUnitId = newModel.ecologicalUnitId
                    this.items[0].model.farmId = newModel.farmId
                    this.items[0].model.area = newModel.area
                    this.items[0].model.headWidth = newModel.headWidth
                    this.items[1].model.variety = newModel.variety
                    this.items[1].model.age = newModel.age
                    this.items[1].model.description = newModel.description
                    this.items[2].model.harvestSpeed = newModel.harvestSpeed
                    this.items[2].model.machineEfficiency = newModel.machineEfficiency
                    this.items[2].model.plantingWidth = newModel.plantingWidth
                    this.items[2].model.nivelationWidth = newModel.nivelationWidth
                    this.items[2].model.visibility = newModel.visibility
                    this.items[2].model.distanceToMill = newModel.distanceToMill
                    this.items[3].model.tchp = newModel.tchp
                    this.items[3].model.tch = newModel.tch
                    this.items[3].model.TCHR = newModel.TCHR
                    this.items[3].model.grooves = newModel.grooves
                    this.items[3].model.kgPerGroove = newModel.kgPerGroove
                    this.items[3].model.groovesPerHectare = newModel.groovesPerHectare
                }
            }
        }
    }
}
